import type { LC_SyncMonthlyCutsRexOut, MonthlyCutsRexSyncSummary } from '../types';


export function mapMonthlyCutsRexSyncSummary(
  transport: LC_SyncMonthlyCutsRexOut,
): MonthlyCutsRexSyncSummary {
  return {
    syncedItems: (transport.syncedItems ?? []).map((item) => ({
      monthlyCutId: item.monthlyCutId,
      processNumber: item.processNumber,
    })),
    alreadySyncedIds: transport.alreadySyncedIds ?? [],
    failedIds: transport.failedIds ?? [],
    notApplicableIds: transport.notApplicableIds ?? [],
    notFoundIds: transport.notFoundIds ?? [],
  };
}
